import { Button, ButtonStyles, DefaultContentComponent, Popup, PopupStyles } from '@silverfort/sf-components';
import { FC, memo } from 'react';

interface DeleteFooterProps {
    onCancel: () => void;
    onApprove: () => void;
}

interface DeleteAppUsersPopupProps {
    open: boolean;
    onClose: () => void;
    onDelete: () => void;
    selections: number;
}

const DeleteFooter: FC<DeleteFooterProps> = memo(({ onCancel, onApprove }) => (
    <div className="flex flex-1 justify-end gap-2 ">
        <Button buttonStyle={ButtonStyles.GhostSolid} text="Cancel" onClick={onCancel} />
        <Button buttonStyle={ButtonStyles.DangerSolid} text="Delete" onClick={onApprove} />
    </div>
));

const DeleteAppUsersPopup: FC<DeleteAppUsersPopupProps> = memo(({ open, onClose, onDelete, selections }) => {
    const title = selections === 1 ? 'Delete API?' : `Delete ${selections} APIs?`;
    return (
        <Popup
            open={open}
            title={title}
            style={PopupStyles.Confirmation}
            ContentComponent={DefaultContentComponent}
            ContentComponentProps={{ text: 'This action can not be undone.' }}
            FooterComponent={DeleteFooter}
            onApprove={onDelete}
            onClose={onClose}
        />
    );
});

export default DeleteAppUsersPopup;
